export const WEEK_DAYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday'
]

export function createDefaultAvailableDays () {
  return WEEK_DAYS.map(day => ({
    day,
    open: true,
    open_from: '10:00',
    open_to: '22:00',
    intervals: []
  }))
}

export function normalizeTimeValue (val) {
  if (val === null || val === undefined) return ''
  if (typeof val === 'object' && Object.keys(val).length === 0) return ''
  if (Array.isArray(val) && val.length === 0) return ''
  return val
}

export function normalizeAvailableDays (apiDays) {
  const byDay = {}
  if (Array.isArray(apiDays)) {
    apiDays.forEach(day => {
      if (day && day.day) {
        byDay[day.day] = {
          day: day.day,
          open: !!day.open,
          open_from: normalizeTimeValue(day.open_from),
          open_to: normalizeTimeValue(day.open_to),
          intervals: Array.isArray(day.intervals)
            ? day.intervals.map(interval => ({
              open_from: normalizeTimeValue(interval.open_from),
              open_to: normalizeTimeValue(interval.open_to)
            }))
            : []
        }
      }
    })
  }

  return WEEK_DAYS.map(day => {
    if (byDay[day]) {
      return byDay[day]
    }
    return {
      day,
      open: false,
      open_from: '',
      open_to: '',
      intervals: []
    }
  })
}

export function prepareAvailableDaysForSave (availableDays) {
  return WEEK_DAYS.map(dayName => {
    const source = (availableDays || []).find(d => d.day === dayName) || {
      day: dayName,
      open: false,
      open_from: '',
      open_to: '',
      intervals: []
    }

    if (!source.open) {
      return {
        day: dayName,
        open: false,
        open_from: null,
        open_to: null,
        intervals: []
      }
    }

    const intervals = (source.intervals || [])
      .map(interval => ({
        open_from: normalizeTimeValue(interval.open_from),
        open_to: normalizeTimeValue(interval.open_to)
      }))
      .filter(interval => interval.open_from && interval.open_to)

    return {
      day: dayName,
      open: true,
      open_from: normalizeTimeValue(source.open_from),
      open_to: normalizeTimeValue(source.open_to),
      intervals
    }
  })
}

export function validateAvailableDays (availableDays) {
  const errors = []

  ;(availableDays || []).forEach(day => {
    if (!day.open) return

    if (!normalizeTimeValue(day.open_from) || !normalizeTimeValue(day.open_to)) {
      errors.push(day.day)
      return
    }

    ;(day.intervals || []).forEach(interval => {
      const from = normalizeTimeValue(interval.open_from)
      const to = normalizeTimeValue(interval.open_to)
      if ((from && !to) || (!from && to)) {
        errors.push(day.day)
      }
    })
  })

  return errors.length === 0
}



// WEBPACK FOOTER //
// ./src/components/UIComponents/availableDaysSchedule.js